import React from 'react'

import { Checkbox } from 'material-ui'

const AllWorkersSelector = ({ checked, onToggleSelectAll }) =>
  <div
    key={-1}
    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingLeft: 0, paddingRight: 0, paddingTop: 4, paddingBottom: 4 }}
    onTouchTap={() => { onToggleSelectAll(!checked) }}>
    <Checkbox
      style={{ width: 24 }}
      iconStyle={{ fill: '#8c8c8c' }}
      checked={checked} />
    <span style={{ marginLeft: 8 }}>All Members</span>
  </div>

export default AllWorkersSelector



// WEBPACK FOOTER //
// ./src/schedule/workers/AllWorkersSelector.js